import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./GestionDirector.css";
import ResponsiveActionSidebar from "../components/ResponsiveActionSidebar";


const GestionDirector = ({ user }) => {
  const nombre = user?.nombre ? user.nombre : "Director";

  // Enlaces para la gestión del director
  const links = [
    { path: "/centro-control-director", label: "Administrar Usuarios" },
    { path: "/GestionCursos", label: "Gestionar Cursos" },
    { path: "/director/progreso-alumnos", label: "Seguimiento de alumnos" },
    { path: "/Autorizaciones", label: "Autorizaciones y acciones sensibles" },
    { path: "/GestionAnuncios", label: "Comunicados" },
    { path: "/Registro", label: "Registro de Actividades" },
    { path: "/mensajeria-interna", label: "Mensajería Corporativa" },
    { path: "/configuracion", label: "Configuración" },
  ];



  return (
    <div className="gd-container gd-container--director-home">
      
      <div className="gd-main-container">
        {/* Área principal de contenido */}
        <div className="gd-content">
        <div className="titulo-director">
                    <img
                      src="/logos/logos_jerarquicos/1.logo_director.png"
                      alt="Logo Director"
                      className="logo-director"
                    />
                    <h1 className="texto-director">CENTRO DE COORDINACIÓN DEL DIRECTOR</h1>
                  </div> <br></br>
          <h2>Bienvenido, Sr. {nombre}</h2> <br></br>
          <p>En esta academia, cada día es una nueva oportunidad no solo para los alumnos, sino para todos nosotros, de crecer, aprender y avanzar juntos. Cada tarea que realizamos contribuye al desarrollo de nuestro equipo y al logro de nuestros objetivos. Hagamos que hoy sea un gran día y recuerda siempre:</p>
          <br></br>
          <p> ¡Tú puedes!  </p>
        </div>
        {/* Sidebar con enlaces */}
        <ResponsiveActionSidebar
          id="gd-director-sidebar"
          className="gd-sidebar"
          openClassName="gd-sidebar--open"
          toggleClassName="gd-sidebar-toggle"
          label="Menú"
          ariaLabel="Acciones del director"
        >
          <ul className="gd-links">
            {links.map((link) => (
              <li key={link.path} className="gd-link-item">
                <Link to={link.path} className="gd-link">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </ResponsiveActionSidebar>
      </div>
    </div>
  );
};

GestionDirector.propTypes = {
  user: PropTypes.shape({
    nombre: PropTypes.string,
  }),
};

GestionDirector.defaultProps = {
  user: null,
};

export default GestionDirector;
